export const prepareFastbookingHero = ({ hero = document.querySelector(".c-heroslider"), fastbooking = document.querySelector(".c-fastbooking") } = {}) => {
  if (!hero || hero.dataset.embedfastbooking !== "true" || !fastbooking || document.querySelector(".mod--new-services")) {
    return null;
  }

  const heroRoot = hero.parentElement;
  const target = heroRoot?.querySelector(".container-fastbooking-hero-JS");
  const wrapper = fastbooking.closest(".web-inherited-reference");

  if (!heroRoot || !target || !wrapper) {
    return null;
  }

  heroRoot.classList.add("inject-fastbooking-true");
  wrapper.classList.add("inject-fastbooking");

  if (wrapper.parentElement !== target) {
    target.appendChild(wrapper);
  }

  return { wrapper, target };
};
